import * as React from "react"
import styled from "styled-components"
import { Button } from "react-bootstrap"
import { useConfig } from "../../../hooks/use-config"

const StyledHeroContainer = styled("div")`
  .co-xv {
    background-image: linear-gradient(to right bottom,#051937,#004d7a,#155055,#135f40,#567512) !important;
    width: 100%;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    height: 400px;
    margin-top: -40px;
  }

  @media (max-width: 574px) {
    .co-xv {
      max-width: 100%;
    }
  }

  @media (min-width: 1200px){ .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl {
    max-width: 100%;
  }
  }
`

const SecurityComplianceHero = () => {
  const { clearout: clearoutConfig } = useConfig()

  return (
    <StyledHeroContainer>
      <div className="co-xv ">
        <div className="text-center mt-5 py-5">
          <h1 className=" text-white">Security & Compliance</h1>
          <p className=" text-white ">
            Clearout is engineered for security and committed to information protection.
          </p>
        </div>
        <div className="text-center">
          <Button href={clearoutConfig.app.registerUrl} target="_blank" className="btn btn-primary btn-free-credits fw-bold px-4">Signup & Get 100 Free Credits</Button>
        </div>
      </div>
    </StyledHeroContainer>
  )
}

export default SecurityComplianceHero
